import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import { Configs } from 'src/app/core/common/configs';
import { WithinKSAInterceptor } from 'src/app/custom/interceptors/within-ksa.interceptor';

/* Add domain specific singleton services here */
export function services() {
  return [];
}
export function interceptors() {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithinKSAInterceptor,
      multi: true,
      deps: [Configs],
    },
  ];
}
export function gurads() {
  return [];
}

@NgModule()
export class CustomModule {
  constructor() {
    const parentModule = inject(CustomModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error('CustomModule is already loaded. Import it in the AppModule only');
    }
  }
  public static forRoot(): ModuleWithProviders<CustomModule> {
    return {
      ngModule: CustomModule,
      providers: [...services(), ...interceptors(), ...gurads()],
    };
  }
}
